export default "__VITE_ASSET__BgOwZ6ak__"